/**
 * 生成随机字符串
 * @param {number} len 长度
 * @returns {string} 随机串
 */
export function getRandomStr(len) {
    const base = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < len; i++) {
        const randomIndex = Math.floor(Math.random() * base.length);
        result += base[randomIndex];
    }
    return result;
}

/** 后端 isAdmin 可能是 boolean / 0|1 / 字符串 */
export function parseIsAdmin(value) {
    return value === true || value === 1 || value === '1' || value === 'true';
}
export function parseIsSuperAdmin(value) {
    return value === true || value === 1 || value === '1' || value === 'true';
}

export function getStoredUserInfo() {
    try {
        const raw = localStorage.getItem('userInfo');
        if (!raw) return null;
        const info = JSON.parse(raw);
        if (!info || typeof info !== 'object') return null;
        return {
            ...info,
            isAdmin: parseIsAdmin(info.isAdmin),
        };
    } catch (e) {
        return null;
    }
}

export function notifyUserInfoUpdated() {
    window.dispatchEvent(new CustomEvent('user-info-updated'));
}

/** 请求拦截器 401 登出后的 reject 标记，业务层可忽略 */
export function isUnauthorizedError(err) {
    return !!(err && err.__unauthorized);
}